import { semanticTokenVars } from '@tundr/ds-tokens';
import { globalStyle, style } from '@vanilla-extract/css';

export const singleSelectCheckIconClass = style({
  color: semanticTokenVars.surface.background.brand.default.base,
});

export const singleSelectCheckIconHiddenClass = style({
  opacity: 0,
});

export const selectionCheckboxClass = style({
  display: 'flex',
  justifyContent: 'center',
});

/**
 * The DS `Checkbox` always wraps itself in a `FormField`, whose container is
 * `width: 100%` even with no label, error or helper to render: the single flex
 * child fills the line and `justify-content` has nothing left to distribute, so
 * the control sits at the left edge of the cell however wide the column is.
 * Shrinking the wrapper to its content hands the centring back.
 *
 * The selector doubles up on `.internal-checkbox` on purpose: a single class
 * would tie with `FormField`'s own on specificity and the winner would be
 * whichever stylesheet the bundler emits last. Remove all of it once `Checkbox`
 * stops mounting an empty `FormField`.
 */
globalStyle(`.internal-checkbox${selectionCheckboxClass} > *`, {
  width: 'fit-content',
});
